"use client";
import { useState as u, useCallback as l } from "react";
function r() {
  const [t, e] = u(!1), s = l(async () => (e(!0), setTimeout(() => {
    e(!1);
  }, 1e3), !0), []);
  return [t, s];
}
export {
  r as useSettleAction
};
